import React from 'react'

export const TechnicianListPage = React.lazy(() => import('./list-technician'))
